<div class="overlay">
  <div class="row form_inputFields">
  <div class="col-6">
    <span class="form_field ms-2" > State</span>
    <span class="color_red">*</span>
    <div style="display: block; "  >
      <app-dropdown class="custom-dropdown" [options]="stateData" [(ngModel)]="selectedState" placeholder="Select State"
      [filter]="true" filterBy="state_name"    (onChange)=onStateChange() optionLabel="state_name"></app-dropdown>
    </div>
  </div>
  <div class="col-6">
    
      <span class="form_field ms-2" > Branch</span>
      <span class="color_red">*</span>
     
    <div style="display: block;">
      <app-dropdown class="custom-dropdown" placeholder="Select Branch" [options]="branchData"
      [filter]="true" filterBy="name"   [(ngModel)]="selectedBranch" (onChange)=onBranchSelect() optionLabel="name"></app-dropdown>
    </div>
  </div>
  </div>  
  </div>
